import {apsViewModels} from "../shared/dto/APS.ViewModels";
import * as _ from "lodash";

export class DowntimeType {
  downtimeTypeId: string;
  downtimeTypeDescription: string;

  constructor(downtimeTypeId: string, downtimeTypeDescription: string) {
    this.downtimeTypeId = downtimeTypeId;
    this.downtimeTypeDescription = downtimeTypeDescription;
  }
}

export class DowntimeReason {
  id: string;
  code: number;
  description: string;
  entireMachine: boolean;
  downtimeType: DowntimeType;

  constructor(viewModel: apsViewModels.DowntimeReasonSelection,
              downtimeTypes: DowntimeType[]) {
    this.id = viewModel.id;
    this.code = viewModel.code;
    this.description = viewModel.description;
    this.entireMachine = viewModel.entireMachine;

    let downtimeType = _.find(downtimeTypes, {downtimeTypeId: viewModel.downtimeTypeId});
    if (!downtimeType) {
      downtimeType = new DowntimeType(
        viewModel.downtimeTypeId,
        viewModel.downtimeTypeDescription);
      downtimeTypes.push(downtimeType);
    }

    this.downtimeType = downtimeType;
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/models/downtime.ts